import { Popconfirm } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from 'react';
import {
  setTableColumnSelection,
  clearCmdbCiVMInstanceMessages,
  CmdbCiVMInstanceSelector,
} from '../../../../store/serviceNow/cmdbCiVMInstance/cmdbCiVMInstance.reducer';
import { useAppDispatch, useAppSelector } from '../../../../store/app.hooks';
import { deleteCmdbCiVMInstance, searchCmdbCiVMInstance } from '../../../../store/serviceNow/cmdbCiVMInstance/cmdbCiVMInstance.action';
import _ from 'lodash';
import CmdbCiVMInstanceService from '../../../../services/serviceNow/cmdbCiVMInstance/cmdbCiVMInstance.service';
import {
  FilterByDateSwap,
  FilterWithSwapOption,
} from '../../../../common/components/DataTable/DataTableFilters';
import { IMainTable, ISearch } from '../../../../common/models/common';
import { useHistory } from 'react-router-dom';
import DataTable from '../../../../common/components/DataTable';
import ability, { Can } from '../../../../common/ability';
import { Action, Page } from '../../../../common/constants/pageAction';
import { showDateFromApi } from '../../../../common/helperFunction';

const MainTable: React.ForwardRefRenderFunction<unknown, IMainTable> = (props, ref) => {
  const {
    setSelectedId,
    setShowSelectedListModal,
    setValuesForSelection,
    isMultiple,
    setFilterKeys,
    tableButtons,
  } = props;
  const CmdbCiVMInstance = useAppSelector(CmdbCiVMInstanceSelector);
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();
  const [ObjectForColumnFilter, setObjectForColumnFilter] = useState({});

  useImperativeHandle(ref, () => ({
    refreshData() {
      dataTableRef?.current.refreshData();
    },
  }));

  useEffect(() => {
    if (isMultiple) {
      dataTableRef?.current.getValuesForSelection();
    }
  }, [isMultiple]);

  const exportExcelFile = (searchData: ISearch) => {
    return CmdbCiVMInstanceService.exportExcelFile(searchData);
  };

  const FilterBySwap = (dataIndex: string, form, columnWidthOpt?: boolean, isRelativeDropDownFlag?: boolean) => {
    setFilterKeys(ObjectForColumnFilter);
    return FilterWithSwapOption(
      dataIndex,
      CmdbCiVMInstance.search.tableName,
      form,
      null,
      ObjectForColumnFilter,
      null,
      columnWidthOpt === undefined ? false : columnWidthOpt,
      isRelativeDropDownFlag
    );
  };

  const FilterByDateSwapTable = (dataIndex: string, tableName: string, form: any) => {
    return FilterByDateSwap(dataIndex, tableName, form, null, ObjectForColumnFilter);
  };

  const getTableColumns = (form) => {
    return [
      {
        title: <span className="dragHandler">ID</span>,
        column: 'id',
        sorter: true,
        ellipsis: true,
        children: [
          {
            title: FilterBySwap('id', form, true),
            dataIndex: 'id',
            key: 'id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Name</span>,
        column: 'Name',
        sorter: true,
        children: [
          {
            title: FilterBySwap('name', form),
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Tenant Name</span>,
        column: 'TenantId',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'tenant_id',
              form,
              false,
              true
            ),
            dataIndex: 'tenant_name',
            key: 'tenant_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Company Name</span>,
        column: 'CompanyId',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'company_id',
              form,
              false,
              true
            ),
            dataIndex: 'company_name',
            key: 'company_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Bu Name</span>,
        column: 'BU_Id',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'bu_id',
              form,
              false,
              true
            ),
            dataIndex: 'bu_name',
            key: 'bu_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Date Added</span>,
        column: 'Date Added',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('date_added', CmdbCiVMInstance.search.tableName, form),
            dataIndex: 'date_added',
            key: 'date_added',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Object ID</span>,
        column: 'object_id',
        sorter: true,
        children: [
          {
            title: FilterBySwap('object_id', form),
            dataIndex: 'object_id',
            key: 'object_id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">System Class Name</span>,
        column: 'sys_class_name',
        sorter: true,
        children: [
          {
            title: FilterBySwap('sys_class_name', form),
            dataIndex: 'sys_class_name',
            key: 'sys_class_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">State</span>,
        column: 'state',
        sorter: true,
        children: [
          {
            title: FilterBySwap('state', form),
            dataIndex: 'state',
            key: 'state',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">CPUs</span>,
        column: 'cpus',
        sorter: true,
        children: [
          {
            title: FilterBySwap('cpus', form),
            dataIndex: 'cpus',
            key: 'cpus',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">DNS Domain</span>,
        column: 'dns_domain',
        sorter: true,
        children: [
          {
            title: FilterBySwap('dns_domain', form),
            dataIndex: 'dns_domain',
            key: 'dns_domain',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">FQDN</span>,
        column: 'fqdn',
        sorter: true,
        children: [
          {
            title: FilterBySwap('fqdn', form),
            dataIndex: 'fqdn',
            key: 'fqdn',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">NG Assignment Flag</span>,
        column: 'ng_assignment_flag',
        sorter: true,
        children: [
          {
            title: FilterBySwap('ng_assignment_flag', form),
            dataIndex: 'ng_assignment_flag',
            key: 'ng_assignment_flag',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Server</span>,
        column: 'server',
        sorter: true,
        children: [
          {
            title: FilterBySwap('server', form),
            dataIndex: 'server',
            key: 'server',
            ellipsis: true,
          },
        ],
      },
    ];
  };

  const removeCmdbCiVMInstance = (id: number) => {
    dispatch(deleteCmdbCiVMInstance(id));
  };

  const tableAction = (_, data: any) => (
    <div className="btns-block">
      <Can I={Action.Update} a={Page.CmdbCiVMInstance}>
        <a
          className="action-btn"
          onClick={() => {
            setSelectedId(data.id);
            history.push(`/service-now/service-now-cmdb-ci-vm-instance/${data.id}`);
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/images/ic-edit.svg`} alt="" />
        </a>
      </Can>
      <Can I={Action.Delete} a={Page.CmdbCiVMInstance}>
        <Popconfirm title="Delete Record?" onConfirm={() => removeCmdbCiVMInstance(data.id)}>
          <a href="#" title="" className="action-btn">
            <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
          </a>
        </Popconfirm>
      </Can>
    </div>
  );

  return (
    <>
      <DataTable
        ref={dataTableRef}
        showAddButton={ability.can(Action.Add, Page.CmdbCiVMInstance)}
        setSelectedId={setSelectedId}
        tableAction={tableAction}
        exportExcelFile={exportExcelFile}
        getTableColumns={getTableColumns}
        reduxSelector={CmdbCiVMInstanceSelector}
        searchTableData={searchCmdbCiVMInstance}
        clearTableDataMessages={clearCmdbCiVMInstanceMessages}
        setTableColumnSelection={setTableColumnSelection}
        setShowSelectedListModal={setShowSelectedListModal}
        setValuesForSelection={setValuesForSelection}
        showBulkUpdate={ability.can(Action.Update, Page.CmdbCiVMInstance)}
        setObjectForColumnFilter={setObjectForColumnFilter}
        tableButtons={tableButtons}
      />
    </>
  );
};

export default forwardRef(MainTable);
